import { Lease } from '../entity'

export const extractAllLeaseEmails = (lease: Lease) => {
  const lessorEmails = lease?.lessors?.map((lessor) => lessor.emailAddress).filter((lessor) => lessor) as string[]
  const lesseeEmails = lease?.lessees?.map((lessee) => lessee.emailAddress).filter((lessee) => lessee) as string[]
  return [...lessorEmails, ...lesseeEmails]
}
